<template>
  <div class="page component-page">
    <div class="left-box" :style="{width: leftBoxWidth + 'px'}">
      <classify-tree
        :tree="categoryTree"
        :expanded="expandCategories"
        :node-key="treeNodeKey"
        filter-key="filteredCount"
        @selected="onCategorySelected" />
    </div>
    <div class="resize-divider" @mousedown="startResize"></div>
    <div class="middle-box">
      <div class="middle-search-box">
        <div class="padding-lr scrollbar-gap search-area" :class="{'cs-search-area':isCyberStation}">
          <div class="top">
            <div v-if="!isBimmake" class="flex-line">
              <span class="search-label">{{ $t('component.filterTitle') }}</span>
              <div class="search-content">
                <el-checkbox v-model="hasPlaceholder" @change="value=>onCheckboxChange(value,'hasPlaceholder')">
                  <img :src="isEn ? require(`@/assets/image/icon_tuli_en.png`):require(`@/assets/image/icon_tuli_zh.png`)" width="16" class="badge badge-placeholder" />
                  {{ $t('component.filterHasPlaceholder') }}
                </el-checkbox>
                <el-checkbox v-model="isParametric" @change="value=>onCheckboxChange(value,'isParametric')">
                  <img :src="isEn ? require(`@/assets/image/icon_canshu_en.png`):require(`@/assets/image/icon_canshu_zh.png`)" width="16" class="badge badge-parametric" />
                  {{ $t('component.filterIsParametric') }}
                </el-checkbox>
              </div>
            </div>
            <div v-if="['bimmake'].includes(softwareCode)" class="flex-line">
              <span class="search-label">{{ $t('component.filterFormat') }}</span>
              <div class="search-content">
                <el-radio-group v-model="suffix" @change="()=>initPage()">
                  <el-radio label="gac" />
                  <el-radio label="skp" />
                </el-radio-group>
              </div>
            </div>
            <div class="search-part flex-line">
              <div v-if="isZh && ['AppGarch', 'AppGmep'].includes(softwareCode)" class="ft-theme cursor-pointer mg-rt-md" @click="toScene">{{ $t('component.filterMoreSearch') }}</div>
              <suggestion-search
                  class="suggestion-search"
                  :placeholder="$t('component.filterKeywordPlaceholder')"
                  :keyword="payload.keyword"
                  @select-suggestion="trackForSuggestion"
                  @keyword-changed="onKeywordChanged"
                  :fetch-suggestions="getSuggestions" />
            </div>
          </div>
          <div class="search-condition-area flex-container flex-row flex-horiz-apart flex-verti-center">
            <search-condition :filters="filters" :totalCount="totalCount" @refresh="getList" @close="closeFilters" />
          </div>
        </div>
        <div class="padding-lr scrollbar-gap filter-area">
          <property-filter
            v-if="propertiesAgg.length"
            :agg-category="aggCategory"
            :properties="propertiesAgg"
            @property-filtered="onPropertyChanged"
            @agg-category-selected="onAggCategorySelected"
            />
        </div>
        <div class="padding-lr scrollbar-gap operate-area operate-and-layout">
          <div v-if="platform !== 'cs'">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" style="margin-right: 20px;" @change="handleCheckAllChange">{{ $t('component.operationSelectAll') }}</el-checkbox>
            <el-button v-if="!hideLoadBtn" plain :disabled="!selectedCount" @click="loadBatch">{{ $t('load.batchLoad') }}{{ selectedCount? `( ${selectedCount} )`: '' }}</el-button>
          </div>
          <div>
          <span class="icon-type" :class="{'active': listType === 'card'}" @click="changeListType('card')">
            <i class="gjw-iconfont gjw-icon-libiao1"/>
          </span>
            <span class="icon-type" :class="{'active': listType === 'row'}" @click="changeListType('row')">
            <i class="gjw-iconfont gjw-icon-libiao2"/>
          </span>
          </div>
        </div>
      </div>
      <gjw-dimensions @height-changed="getContentHeight">
      <div class="middle-result-box">
        <div class="data-content" :style="{height: `${contentHeight}px`}">
          <div v-show="loading" class="loading-mask" v-loading="loading" element-loading-background="rgba(245, 245, 250, 0.8)"></div>
          <ul
            v-if="loading || tableData.length"
            class="list-ul padding-lr"
            :class="{ 'list-ul-card': listType === 'card' }"
          >
            <li
                v-for="(item, index) in tableData"
                :key="index"
                class="list-li"
                :class="listType === 'card' ? 'card-li' : 'row-li'"
                @click.stop="openDetail($event, item, index)"
            >
              <list-item :class="{'active-item': activeIndex === index }" :comp-item="item" :type="listType" @check-change="handleCheckChange"/>
            </li>
          </ul>
          <div v-else class="empty">
            <empty-content :text="$t('component.emptyNoResult')" />
          </div>
        </div>
      </div>
      </gjw-dimensions>
      <div class="middle-pagination-box scrollbar-gap">
        <el-pagination
            small
            background
            hide-on-single-page
            @current-change="currentChange"
            :current-page="payload.pageNo"
            :page-size="payload.pageSize"
            layout="prev, pager, next"
            :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <div v-if="showDetail" class="right-box">
      <detail :detail="detail" @close="closeDetail"/>
    </div>
    <!-- 载入重名弹框 -->
    <check-rename-dialog ref="CheckRenameDialogRef" :dialogVisible="checkRenameDialogVisible" :selectedList="selectedData" @confirm="handleConfirmConfirm" @close="checkRenameDialogVisible = false"/>
    <!-- 载入 -->
    <load-progress-bar-dialog ref="LoadProgressBarDialogRef" :selectedList="selectedData" @clearSelection="clearSelection"/>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { CheckPublicComponentLoaded, GetProjectInfo, LoadPublicComponentInBatch, RecordJournal, buildPublicComponentPayload } from '@/core/gcsUtils'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import defaultViewMixin from '@/mixins/defaultViewMixin'
import DecoSoftware from '@/assets/js/decoSoftware'
import BimmakeSoftware from '@/assets/js/bimmakeSoftware'
import GjwDimensions from '@/components/lib/GjwDimensions'
import ListItem from '@/views/components/components/ListItem.vue'
import EmptyContent from '@/components/layout/EmptyContent.vue'
import ClassifyTree from './components/ClassifyTree'
import SuggestionSearch from './components/SuggestionSearch'
import SearchCondition from './components/SearchCondition.vue'
import PropertyFilter from './components/PropertyFilter.vue'
import gcsReplayRecordMixin from '@/mixins/gcsReplayRecordMixin'
import CheckRenameDialog from './components/CheckRenameComponentDialog.vue'
import LoadProgressBarDialog from './components/LoadProgressBarDialog.vue'
import Detail from './Detail.vue'
import Big from 'big.js'
import Utils from '@/core/utils'
import { SEARCH_KEYWORD_MAX_LENGTH } from './constants'
export default {
  name: 'ComponentList',
  mixins: [checkLoginMixin, defaultViewMixin, gcsReplayRecordMixin],
  components: {
    GjwDimensions,
    ListItem,
    ClassifyTree,
    SuggestionSearch,
    SearchCondition,
    EmptyContent,
    PropertyFilter,
    Detail,
    CheckRenameDialog,
    LoadProgressBarDialog
  },
  filterMap: {
    keyword: {
      nameKey: 'component.filterKeyword',
      order: 0,
      transform: (vue, value) => {
        if (value) {
          value = value.trim()
          if (value.length > SEARCH_KEYWORD_MAX_LENGTH) {
            value = value.substr(0, SEARCH_KEYWORD_MAX_LENGTH)
          }
        }
        return value
      }
    },
    gjwCategoryId: {
      nameKey: 'component.filterCategory',
      order: 1,
      transform: (vue, value) => {
        // 特别处理不展示分类：全部
        if (vue.rootCategory.id === value) return null
        const category = vue.getCategoryByIdFn(Number(value)) || {}
        return category.name
      }
    },
    spaceCategoryId: {
      nameKey: 'component.filterCategory',
      order: 1,
      transform: (vue, value) => {
        // 特别处理不展示分类：全部
        if (vue.rootCategory.id === value) return null
        const category = vue.getCategoryByIdFn(Number(value)) || {}
        return category.name
      }
    },
    hasPlaceholder: {
      nameKey: 'component.filterHasPlaceholder',
      order: 6,
      transform: (vue, value) => {
        return value ? vue.$t('common.yes') : ''
      }
    },
    isParametric: {
      nameKey: 'component.filterIsParametric',
      order: 7,
      transform: (vue, value) => {
        return value ? vue.$t('common.yes') : ''
      }
    },
  },
  data() {
    return {
      // card：卡片形式；row: 行列表形式
      listType: 'card',
      // 构件格式（bimmake需要区分）
      suffix: 'gac',
      activeIndex: -1,
      contentHeight: 0,
      treeNodeKey: 'uniqueId',
      loading: false,
      showDetail: false,
      checkAll: false,
      isIndeterminate: false,
      tableData: [],
      totalCount: 0,
      payload: { pageNo: 1, pageSize: 28 },
      hasPlaceholder: false,
      isParametric: false,
      propertiesAgg: [],
      // 分类节点的层级
      nodeLevel: null,
      detail: null,
      aggCategory: null, // 前端聚合出来的分类信息，并能控制智能推荐是否展示
      checkRenameDialogVisible: false,
      // 左侧面板宽度
      leftBoxWidth: 152,
      isResizing: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedData: 'componentList/selectedData',
      platCategories: 'componentList/platCategories',
      categoryTree: 'componentList/categoryTree',
      rootCategory: 'componentList/rootCategory',
      getCategoryByIdFn: 'componentList/getCategoryById',
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      language: 'language',
    }),
    // 是否是中文环境
    isZh() {
      return this.language === 'zh_CN'
    },
    // 是否是英文环境
    isEn() {
      return this.language.startsWith('en_')
    },
    platformCode() {
      const mappingObj = { g: 'NOVA_DESIGN', r: 'REVIT', cs: 'NOVA_DESIGN', bimmake: 'GENERAL' }
      const key = ['bimmake'].includes(this.softwareCode) ? this.softwareCode : this.platform
      return mappingObj[key] ? mappingObj[key] : null
    },
    // 是否是装饰软件
    isAppDeco() {
      return this.softwareCode === 'AppDeco'
    },
    // 是否是深化设计软件
    isBimmake() {
      return this.softwareCode === 'bimmake'
    },
    // 是否是CyberStation软件
    isCyberStation() {
      return this.platform === 'cs'
    },
    filters() {
      const filters = this.payload || []
      return Object.keys(filters).map((key) => {
        const map = this.$options.filterMap[key]
        return map ? {
          name: map.nameKey ? this.$t(map.nameKey) : map.name,
          key,
          order: map.order,
          value: map.transform(this, filters[key])
        } : null
      }).filter((filter) => filter && filter.name && filter.value).sort((f1, f2) => f1.order - f2.order)
    },
    currentCategory() {
      const gjwCategoryId = this.payload.categoryUniqueId || this.rootCategory[this.treeNodeKey] || 0
      return this.getCategoryByIdFn(gjwCategoryId, this.treeNodeKey)
    },
    selectedCount() {
      return this.selectedData.length
    },
    expandCategories() {
      // 没有过滤属性返回不需要展开该分类
      const item = this.propertiesAgg && this.propertiesAgg.length ? this.aggCategory : null
      return [this.currentCategory, item]
    },
    hideLoadBtn() {
      // CyberStation软件不显示载入按钮
      return this.isCyberStation
    }
  },
  created() {
    this.getCategories(true)
    this.search()
  },
  methods: {
    ...mapMutations({
      setSelectedData: 'componentList/setSelectedData'
    }),
    ...mapActions({
      loadCategories: 'componentList/loadCategories',
      refreshCategories: 'componentList/refreshCategories'
    }),
    getContentHeight(obj) {
      this.contentHeight = obj.newValue.toFixed(0) - 4
    },
    startResize(e) {
      this.isResizing = true
      const startX = e.clientX
      const startWidth = this.leftBoxWidth

      const onMouseMove = (e) => {
        if (!this.isResizing) return
        const deltaX = e.clientX - startX
        let newWidth = startWidth + deltaX
        // 限制最小和最大宽度
        if (newWidth < 100) newWidth = 100
        if (newWidth > 500) newWidth = 500
        this.leftBoxWidth = newWidth
      }

      const onMouseUp = () => {
        this.isResizing = false
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
      }

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
      document.body.style.cursor = 'col-resize'
      document.body.style.userSelect = 'none'
    },
    async initPage() {
      this.nodeLevel = null
      this.clearPropertyFilters()
      this.payload = { pageNo: 1, pageSize: 28 }
      await this.getCategories(true)
      await this.search()
    },
    handleSoftwareParams() {
      let params = {
        softwareCode: this.softwareCode,
        language: this.language,
        ...this.payload
      }
      if (this.softwareCode === 'AppGbr') {
        params.gjw_category_id = this.payload.gjwCategoryId || this.rootCategory.id || 0
      }
      if (this.isAppDeco) {
        const spaceId = DecoSoftware.getSpaceId(process.env.VUE_APP_CURRENT_MODE)
        const softwareVersions = DecoSoftware.getCategoryFilters(this.softwareVersion)
        params.spaceId = spaceId
        params.softwareVersions = softwareVersions
        params.gjwCategoryCode = this.currentCategory.code
        delete params.gjwCategoryId
      } else if (this.isBimmake) {
        const spaceId = BimmakeSoftware.getSpaceId(process.env.VUE_APP_CURRENT_MODE)
        const queryOptions = BimmakeSoftware.getQueryFilters(this.suffix)
        params = {
          spaceId,
          ...params,
          softwareVersion: this.softwareVersion,
          ...queryOptions
        }
      } else {
        params.platformCode = this.platformCode
        params.softwareVersion = this.softwareVersion
        // CyberStation只根据平台查询，不进行软件code查询
        if (this.isCyberStation) {
          delete params.softwareCode
        }
      }
      return params
    },
    async getList() {
      this.setSelectedData([])
      this.closeDetail()
      this.loading = true
      const params = this.handleSoftwareParams()
      try {
        const res = await this.$api.components.list(params)
        const list = res.list || []
        const ids = list.map((item) => { return { id: String(item.publicComponentId), name: item.name } })
        // 获取构件是否已添加
        const { data } = await CheckPublicComponentLoaded(ids)
        const componentsLoadedArr = data || []
        list.forEach((item, index) => {
          const loadedObj = componentsLoadedArr.find((it) => String(it.publicComponentId) === String(item.publicComponentId)) || {}
          item.isLoaded = loadedObj.isLoaded
          item.isChecked = false
          item.sortIndex = params.pageSize * (params.pageNo - 1) + index + 1
        })
        this.tableData = list
        this.totalCount = res.totalCount || 0
        this.updateCheckAllStatus()
        this.searchTrack(params)
      } catch (error) {
        this.$message.error(this.$t('common.getDataFailed'))
      } finally {
        this.loading = false
      }
    },
    toScene() {
      this.$router.push({ name: 'SceneList' })
      this.$tracks({
        event: 'visitSceneList',
        params: {
          g_c_source: 'shop_gjw',
        }
      })
    },
    async search() {
      this.payload.pageNo = 1
      await this.getList()
    },
    async getCategories(first = false) {
      try {
        const params = this.handleSoftwareParams()
        first ? await this.loadCategories(params) : await this.refreshCategories(params)
      } catch (error) {

      }
    },
    getPropertiesAgg() {
      if (this.isBimmake) { return }
      if (this.nodeLevel >= 3) {
        this.loadProperties()
      }
    },
    changeListType(type) {
      this.listType = type
    },
    updateSelectedData(row) {
      const selectedData = [...this.selectedData]
      const index = selectedData.findIndex((it) => it.id === row.id)
      if (row.isChecked && index === -1) {
        // 添加到selectedData中
        selectedData.push(row)
      } else if (!row.isChecked && index > -1) {
        // 在selectedData中删除
        selectedData.splice(index, 1)
      }
      this.setSelectedData(selectedData)
    },
    updateCheckAllStatus() {
      const checkedCount = this.tableData.filter((item) => item.isChecked).length
      const tableLength = this.tableData.length
      this.checkAll = tableLength > 0 && checkedCount === tableLength
      this.isIndeterminate = checkedCount > 0 && checkedCount < tableLength
    },
    handleCheckAllChange(bool) {
      this.tableData = this.tableData.map((item) => {
        item.isChecked = bool
        this.updateSelectedData(item)
        return { ...item, isChecked: bool }
      })
      this.isIndeterminate = false
    },
    handleCheckChange({ item }) {
      this.updateCheckAllStatus()
      this.updateSelectedData(item)
    },
    currentChange(val) {
      this.payload.pageNo = val
      this.getList()
    },
    async openDetail(event, item, index) {
      // 点击多选框时，不打开详情页
      if (event.target.className.includes('el-checkbox')) { return }
      this.activeIndex = index
      this.showDetail = true
      this.detail = item
      const projectInfo = await this.getProjectInfo()
      // 访问详情埋点
      this.$tracks({
        event: 'visitShopComponentDetail',
        params: {
          g_c_component_id: item.publicComponentId,
          g_c_source: 'shop_gjw',
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        }
      })
    },
    closeDetail() {
      this.showDetail = false
      this.detail = {}
      this.activeIndex = -1
    },
    onCheckboxChange(value, key) {
      if (value) {
        this.payload = { ...this.payload, [key]: value }
      } else {
        delete this.payload[key]
        this.payload = { ...this.payload }
      }
      this.search()
      this.getCategories()
    },
    onCategorySelected(category, node) {
      const treeNodeKey = this.treeNodeKey
      if (category[treeNodeKey] === this.currentCategory[treeNodeKey]) return
      this.nodeLevel = node.level
      const categoryObj = this.isBimmake ? {
        spaceCategoryId: category.id, categoryUniqueId: category[treeNodeKey]
      } : {
        gjwCategoryId: category.id, categoryUniqueId: category[treeNodeKey]
      }
      this.payload = { ...this.payload, ...categoryObj }
      // 已经聚合出某个分类且聚合的分类与点击的分类相同，不需要再次获取过滤属性
      if (this.aggCategory && this.aggCategory[treeNodeKey] === category[treeNodeKey]) {
        this.aggCategory = null
      } else {
        this.clearPropertyFilters()
        if (!this.isBimmake) {
          this.getPropertiesAgg()
        }
      }
      this.search()
      this.getCategories()
    },
    async loadProperties(obj = {}) {
      try {
        const params = {
          ...this.payload,
          language: this.language,
          platformCode: 'NOVA_DESIGN',
          softwareCode: this.softwareCode,
          softwareVersion: this.softwareVersion,
          ...obj
        }
        const res = await this.$api.components.searchProperties(params)
        this.propertiesAgg = res || []
      } catch (error) {
        this.propertiesAgg = []
      }
    },
    onPropertyChanged(filters) {
      this.payload = {
        ...this.payload,
        searchPropertyFilters: filters
      }
      if (this.aggCategory) {
        this.onCategorySelected(this.aggCategory, { level: this.aggCategory.level })
      } else {
        this.search()
      }
    },
    clearPropertyFilters() {
      this.propertiesAgg = []
      this.aggCategory = null
      delete this.payload.searchPropertyFilters
    },
    async onKeywordChanged(keyword) {
      if (this.payload.keyword === keyword) {
        return
      }
      this.nodeLevel = null
      this.payload.categoryUniqueId = null
      this.clearPropertyFilters()
      delete this.payload.gjwCategoryId
      delete this.payload.spaceCategoryId
      this.payload = { ...this.payload, keyword }
      await Promise.all([
        this.search(),
        this.getCategories()])
      // 根据结果去决定是否触发三四级分类的过滤搜索
      if (keyword) { this.loadPropertyFiltersByResult() }
    },
    getSuggestions(queryString, cb) {
      return new Promise((resolve, reject) => {
        if (this.isZh) {
          const query = this.isCyberStation ? {
            keyword: queryString,
            platform_code: this.platformCode,
          } : {
            keyword: queryString,
            software_code: this.softwareCode
          }
          this.$api.components.suggestions(query)
            .then((data) => {
              cb(data || [])
              resolve()
            })
            .catch((err) => {
              console.error(err)
              reject(err)
            })
        } else {
          resolve()
        }
      })
    },
    // 通过百度打点,统计用户搜索关键词时，是否采用了提示
    trackForSuggestion(s) {
      if (window._hmt) {
        window._hmt.push(['_trackEvent', 'shopComponentQuery', 'adoptClue', s])
      }
    },
    async closeFilters(filters) {
      try {
        this.clearPropertyFilters()
        filters.forEach((f) => {
          const key = f.key
          if (['gjwCategoryId', 'spaceCategoryId'].includes(key)) {
            this.nodeLevel = null
            this.payload.categoryUniqueId = null
          } else if (['hasPlaceholder', 'isParametric'].includes(key)) {
            this[key] = false
          }
          delete this.payload[key]
        })
        this.payload = { ...this.payload }
        await Promise.all([
          this.search(),
          this.getCategories()
        ])
        const currentFilters = this.filters
        if (currentFilters && currentFilters.length) {
          if (currentFilters.length === 1 && currentFilters[0].key === 'keyword') {
            this.loadPropertyFiltersByResult()
          } else if (currentFilters.some((f) => f.key === 'gjwCategoryId')) {
            this.getPropertiesAgg()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 批量载入
    async loadBatch() {
      try {
        const login = await this.checkLogin()
        if (login) {
          if (['AppGbr'].includes(this.softwareCode)) {
            this.toNewLoad({}, 'batch', this.selectedData).catch()
            return
          }
          this.$fullLoading.open(this.$t('load.loading'))
          const params = this.selectedData.map((comp) => buildPublicComponentPayload(comp))
          RecordJournal('LoadPublicComponentInBatchFromComponents', params)
          await LoadPublicComponentInBatch(params)
          // 载入结果提示无需web端进行提示，但需要清空勾选项
          this.setSelectedData([])
          await this.getList()
        }
      } catch (err) {
        this.$message.error(this.$t('load.batchLoadFailed'))
      } finally {
        this.$fullLoading.close()
      }
    },
    handleConfirmConfirm(data, row, actionType, subdivideType, batchSelectData) {
      switch (actionType) {
        case 'place':
          data.forEach((item) => {
            this.$refs.pluginPlaceTypeDialog?.openDialog(row, true, item.reName === true ? 'FFS_CREATE' : 'FFS_OVERWRITE')
          })
          break
        case 'load':
          if (subdivideType === 'batch') {
            this.$refs.LoadProgressBarDialogRef?.batchOpenDialog(subdivideType, data, batchSelectData)
          }
          break
      }
    },
    async clearSelection() {
      this.setSelectedData([])
      await this.getList()
    },
    async toNewLoad(row, subdivideType = 'batch', batchSelectData) {
      if (subdivideType === 'single') {}
      const componentNames = this.selectedData.length && subdivideType === 'batch' ? this.selectedData.map((item) => item.name) : [row.name]
      const result = await this.$desktopClient.ListComponentsByNames(componentNames)
      if (result.code === 'success') {
        const updatedDataList = result.data
        if (updatedDataList.length) {
          this.checkRenameDialogVisible = true
          this.$refs.CheckRenameDialogRef?.init(updatedDataList, row, 'load', subdivideType, batchSelectData)
        } else if (subdivideType === 'batch') {
          await this.$refs.LoadProgressBarDialogRef?.batchOpenDialog(subdivideType, this.selectedData, this.selectedData)
        }
      }
    },
    async replayLoadPublicComponentInBatch(args) {
      const { code } = await LoadPublicComponentInBatch(args)
      return code === 'success' ? { code: 'success', data: true } : { code: 'failure', message: 'actionName:LoadPublicComponent Failed', data: false }
    },
    // 插件端获取项目信息
    async getProjectInfo() {
      let projectInfo = {}
      if (this.platform === 'g') {
        const { data } = await GetProjectInfo()
        projectInfo = data || {}
      } else if (this.platform === 'r') {
        const { data } = await this.$revitClient.GetProjectInfo()
        projectInfo = data || {}
      }
      return projectInfo
    },
    // 查询埋点
    async searchTrack(params) {
      const propertyFilter = params.searchPropertyFilters || []
      const resultData = this.tableData.map((item) => {
        return { name: item.name, id: item.publicComponentId }
      })
      const g_c_type_search = localStorage.getItem('xAnalysisTypeSearch') === 'undefined' ? false : JSON.parse(localStorage.getItem('xAnalysisTypeSearch'))
      const projectInfo = await this.getProjectInfo()
      this.$tracks({
        event: 'shopComponentQuery',
        params: {
          g_c_keyword: params.keyword || null,
          g_c_default_condition: this.defaultView,
          g_c_condition: {
            platform_code: params.platformCode,
            software_code: params.softwareCode,
            software_version: params.softwareVersion,
            category_id: params.gjwCategoryId,
            has_placeholder: params.hasPlaceholder,
            is_parametric: params.isParametric,
            keyword: params.keyword,
            page_no: params.pageNo,
            page_size: params.pageSize
          },
          g_c_property_filter: propertyFilter,
          g_c_component_result: resultData,
          g_c_result_count: this.totalCount,
          g_c_display_type: this.listType === 'card' ? 'card_mode' : 'list_mode',
          g_c_type_search: g_c_type_search === 'true' ? true : g_c_type_search,
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        }
      })
      // 只有第一次进入页面是缺省，再次打点都认为是false
      if (this.defaultView) {
        this.defaultView = false
      }
    },
    async getAggCategoryNode() {
      try {
        const total = this.totalCount
        if (total) {
          const rateMatched = this.platCategories.reduce((arr, p) => {
            const rate = p.id !== 0 ? Number(Big(p.filteredCount / total).toFixed(2)) : 0
            if (rate > 0.8) {
              arr.push({ ...p, rate })
            }
            return arr
          }, []).sort((a, b) => b.rate - a.rate)
          const levelMatched = rateMatched.reduce((acc, m) => {
            const { ids } = Utils.getPathByChild(this.platCategories, m.id, this.rootCategory.id)
            if (ids.length > 1) {
              acc.push({ ...m, level: ids.length + 1 })
            }
            return acc
          }, [])
          this.aggCategory = levelMatched[0]
        } else {
          this.aggCategory = null
        }
      } catch (error) {
        console.log(error)
        this.aggCategory = null
      }
    },
    async loadPropertyFiltersByResult() {
      await this.getAggCategoryNode()
      if (this.aggCategory) {
        this.loadProperties({ gjwCategoryId: this.aggCategory.id })
      }
    },
    onAggCategorySelected(category) {
      this.onCategorySelected(category, { level: category.level })
    },
  },
}
</script>
<style lang='less' scoped>
.flex-line{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.component-page{
  background: @bg-grey-light;
  display: flex;
  flex-direction: row;
  .left-box{
    flex: 0 0 auto;
    background: @white;
    height: calc(100vh - 40px);
    overflow: auto;
    padding-top: 8px;
  }
  .resize-divider{
    width: 2px;
    background: @theme-border-color;
    cursor: col-resize;
    flex-shrink: 0;
    transition: background 0.2s;
    &:hover{
      background: @theme-color;
    }
  }
  .middle-box{
    flex: 1;
    display: flex;
    flex-direction: column;
    .search-area{
      border-bottom: 1px solid @theme-border-color;
    }
    .cs-search-area{
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
    }
    .middle-result-box{
      flex: 1;
    }
    .middle-pagination-box{
      padding: 6px 0;
      text-align: center;
    }
    .top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 6px 0;
      .search-label{
        margin-right: 20px;
      }
      .search-content{
        .el-checkbox{
          margin-right: 10px;
          font-weight: normal;
          font-size: 1rem;
        }
      }
    }
    .badge {
      position: relative;
      top: 2px;
      &.badge-parametric {
        color: #1a90ff;
      }
      &.badge-placeholder{
        color: #f29d38;
      }
    }
    .operate-and-layout{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .icon-type{
        display: inline-block;
        cursor: pointer;
        padding: 5px 4px 2px;
        border: 1px solid @theme-border-color;
        border-left:none;
        &:first-child{
          border-left: 1px solid @theme-border-color;
        }
        &.active{
          background: @white;
        }
      }
    }
    .search-condition-area{
      margin-bottom: 6px;
    }
    .search-part{
      z-index: 100;
    }
    .suggestion-search{
      width: 280px;
      height: 24px;
    }
    .filter-area{
      margin-top: 8px;
    }
    .operate-area{
      // 与列表区间距放在滚动容器外，滚动时始终保留
      margin-bottom: 10px;
    }
  }
  // 与列表区 scrollbar-gutter 对齐的固定滚动条宽度
  @scrollbar-width: 4px;
  .data-content{
    overflow: auto;
    // 始终预留滚动条槽，与上方 scrollbar-gap 对齐
    scrollbar-gutter: stable;
    position: relative;
  }
  .loading-mask {
    position: absolute;
    left:0;
    top:0;
    width: 100%;
    height: 100%;
  }
  .list-ul{
    box-sizing: border-box;
  }
  .list-ul-card{
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    .card-li{
      flex: 0 0 auto;
      margin: 0;
    }
  }
  .list-li{
    cursor: pointer;
  }
  .row-li{
    width: 100%;
  }
  .right-box{
    flex: 0 0 320px;
    width: 320px;
    background: @white;
    border-left: 1px solid @theme-border-color;
    height: calc(100vh - 40px);
  }
  .padding-lr{
    padding-left: 10px;
    padding-right: 6px;
  }
  // 滚动容器外的区域需额外预留滚动条宽度
  .scrollbar-gap{
    padding-right: calc(10px + @scrollbar-width);
  }
  .empty{
    margin-top: 80px;
  }
}
</style>
